<div class="container-fluid" *ngIf="view === 'list'" data-cy="ordersListView">
  <app-orders-list [financeMode]="financeMode" [filters]="filters" [allowPreferences]="true"></app-orders-list>
</div>

<div class="container-fluid" *ngIf="view === 'detail'" data-cy="ordersDetailView">
  <!-- the *ngIf reloadDetail allows to refresh completely the component -->
  <app-orders-detail [pk]="pk" *ngIf="!reloadDetail" [financeMode]="financeMode" (modeChanged)="onModeChanged($event)"></app-orders-detail>
</div>